import { render } from "./install-app.vue?vue&type=template&id=3d9542f5&scoped=true"
import script from "./install-app.vue?vue&type=script&lang=js"
export * from "./install-app.vue?vue&type=script&lang=js"

import "./install-app.vue?vue&type=style&index=0&id=3d9542f5&scoped=true&lang=css"

import exportComponent from "/opt/buildhome/repo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3d9542f5"]])

export default __exports__